import { usePLCValue } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

import PLCButton from './PLCButton';

function PLCToggleButton({
  path,
  trueLabel,
  falseLabel,
  disabled = false,
  fullWidth = false,
}) {
  const value = usePLCValue(path);
  const nextValue = !value;

  return (
    <PLCButton
      path={path}
      value={nextValue}
      variant={value ? 'primary' : 'normal'}
      disabled={disabled}
      fullWidth={fullWidth}
    >
      {value ? trueLabel : falseLabel}
    </PLCButton>
  );
}

PLCToggleButton.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  trueLabel: PropTypes.node.isRequired,
  falseLabel: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default PLCToggleButton;
